import React from "react";
import {
  LegalPageLayout,
  LegalSection,
  TocItem,
} from "pages/website/LegalPageLayout";

const TERMS_TOC: TocItem[] = [
  { id: "service-description", label: "Service Description" },
  { id: "account-responsibilities", label: "Account Responsibilities" },
  { id: "subscription-payments", label: "Subscription & Payments" },
  { id: "acceptable-use", label: "Acceptable Use" },
  { id: "intellectual-property", label: "Intellectual Property" },
  { id: "suspension-termination", label: "Suspension or Termination" },
  { id: "limitation-liability", label: "Limitation of Liability" },
  { id: "changes-to-terms", label: "Changes to Terms" },
  { id: "governing-law", label: "Governing Law" },
];

const TermsPage: React.FC = () => {
  return (
    <LegalPageLayout
      title="Terms & Conditions"
      icon="📜"
      lastUpdated="Friday, 6th of February, 2026"
      intro={
        <>
          By accessing or using YourQcard, you agree to these Terms &
          Conditions.
        </>
      }
      tocItems={TERMS_TOC}
    >
      <LegalSection
        id="service-description"
        number={1}
        title="Service Description"
      >
        <p>YourQcard provides a digital business card platform for:</p>
        <ul>
          <li>Individuals</li>
          <li>Companies with multiple employees</li>
          <li>QR and NFC-based sharing</li>
          <li>Subscription-based plans</li>
        </ul>
      </LegalSection>

      <LegalSection
        id="account-responsibilities"
        number={2}
        title="Account Responsibilities"
      >
        <ul>
          <li>Users must provide accurate information</li>
          <li>You are responsible for keeping login credentials secure</li>
          <li>Sharing accounts is not allowed unless stated in your plan</li>
        </ul>
      </LegalSection>

      <LegalSection
        id="subscription-payments"
        number={3}
        title="Subscription & Payments"
      >
        <ul>
          <li>Pricing varies by package</li>
          <li>Subscriptions are billed monthly or annually</li>
          <li>Fees are non-refundable unless stated otherwise</li>
          <li>
            YourQcard reserves the right to modify pricing with prior notice
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="acceptable-use" number={4} title="Acceptable Use">
        <p>You agree not to:</p>
        <ul>
          <li>Upload false, misleading, or illegal content</li>
          <li>Impersonate others</li>
          <li>Use the platform for spam or abuse</li>
          <li>Attempt to breach system security</li>
        </ul>
      </LegalSection>

      <LegalSection
        id="intellectual-property"
        number={5}
        title="Intellectual Property"
      >
        <ul>
          <li>
            YourQcard platform, design, and technology are owned by YourQcard
          </li>
          <li>
            Users retain ownership of their content but grant YourQcard the
            right to display it for service operation
          </li>
        </ul>
      </LegalSection>

      <LegalSection
        id="suspension-termination"
        number={6}
        title="Account Suspension or Termination"
      >
        <p>We may suspend or terminate accounts if:</p>
        <ul>
          <li>Terms are violated</li>
          <li>Illegal or abusive activity is detected</li>
          <li>Payments are overdue</li>
        </ul>
      </LegalSection>

      <LegalSection
        id="limitation-liability"
        number={7}
        title="Limitation of Liability"
      >
        <p>YourQcard is provided &quot;as is&quot;. We are not liable for:</p>
        <ul>
          <li>Business losses</li>
          <li>Data loss due to external factors</li>
          <li>Third-party service interruptions</li>
        </ul>
      </LegalSection>

      <LegalSection id="changes-to-terms" number={8} title="Changes to Terms">
        <p>
          We may update these terms at any time. Continued use means acceptance
          of the updated terms.
        </p>
      </LegalSection>

      <LegalSection id="governing-law" number={9} title="Governing Law">
        <p>
          These terms are governed by the laws of Lebanon, unless otherwise
          stated.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default TermsPage;
